import { render, staticRenderFns } from "./Idverification.vue?vue&type=template&id=3c947046&"
import script from "./Idverification.vue?vue&type=script&lang=js&"
export * from "./Idverification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports